<template>
  <div
      :style="estiloMenu"
      class="menu-vertical"
      v-if="!emptyShowList"
  >
    <div
        v-for="(item, index) in columns"
        :key="index"
    >
      <NavButton
          v-show="('show' in item)? item.show : true"
          :action="item.action"
          :title="item.title"
      />
    </div>
  </div>
</template>
<script>
import NavButton from '../buttons/NavButton'
import { mapGetters } from 'vuex'

export default {
  name: 'MenuVertical',
  components: {
    NavButton
  },
  computed: {
    ...mapGetters('SetupApp', ['estilo']),
    estiloMenu () {
      return {
        'background': `${this.estilo.aplicacao.corPrimariaAplicacao}14`,
        'max-width': `${this.width}`
      }
    },
    emptyShowList () {
      return this.columns.filter(item => ('show' in item) ? item.show : true).length === 0
    }
  },
  props: {
    columns: {
      type: Array
    },
    width: {
      type: String,
      default: '100%'
    },
    show: {
      type: Boolean
    }
  }
}
</script>
